import { useInstanceKey } from "app/area/favourite/favourite-context";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCaseTableViewExternalUrlTemplateState } from "app/area/case-report/case-table-view/selectors";
import { getSingleSupplierUrl } from "app/area/case-report/case-table-view/actions";

export function caseTableViewExternalUrlHook() {
  const instanceKey = useInstanceKey();
  const singleSupplierUrl = useSelector(selectCaseTableViewExternalUrlTemplateState(instanceKey));
  const dispatch: any = useDispatch();

  const loadSingleSupplierUrl = useCallback(() => {
    dispatch(getSingleSupplierUrl(instanceKey));
  }, [getSingleSupplierUrl, instanceKey]);

  return {
    loadSingleSupplierUrl,
    singleSupplierUrl
  };
}

